<template>
  <div id="app" ref="app">
      <router-view></router-view>
  </div>
</template>
<script>
  export default {
    data() {
      return {}
    },
    components: {
    }
  }
</script>

<style>
#app {
  display: flex;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>




// WEBPACK FOOTER //
// src/App.vue